// extracted by mini-css-extract-plugin
module.exports = {"main":"AlertTypeCondition-module__main__3FEHD"};